<div class="step-navigation step-navigation-primary pt-1">
    <div class="step-navigation-item" *ngFor="let step of availableSteps; let i = index;" [attr.title]="step.label" [ngClass]="{'active':step.active, 'visited':i < currentActiveStep}">
        <span class="step-navigation-step me-2">{{i+1}}. </span>
        <span class="step-navigation-label d-md-inline-block">{{step.label}}</span>
    </div>
</div>
